import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ToolCheckout from './pages/ToolCheckout';
import ToolManagement from './pages/ToolManagement';
import TransactionHistory from './pages/TransactionHistory';
import SearchPage from './pages/SearchPage';
import EmployeeManagement from './pages/EmployeeManagement';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ToastProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="checkout" element={<ToolCheckout />} />
            <Route path="tools" element={<ToolManagement />} />
            <Route path="transactions" element={<TransactionHistory />} />
            <Route path="search" element={<SearchPage />} />
            <Route path="employees" element={<EmployeeManagement />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;
